



































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AppInput from "@/components/global/AppInput.vue";
import { GiftCard } from "@/models/gift-cards/GiftCard";
import { ValidationProvider } from "vee-validate";
import { formatDate } from "@/helpers/functions/format-date";

@Component({
  name: "GiftCardModal",
  components: { AppInput, ValidationProvider }
})
export default class GiftCardModal extends Vue {
  $refs!: {
    form: HTMLFormElement
  };

  // ===== Props ===== //
  @Prop(Object) private readonly card!: GiftCard;
  @Prop(Boolean) private readonly issued!: boolean;

  // ===== Data ===== //
  public dialog = false;
  public error = false;
  public loading = false;
  public statusOptions = ["Issued", "Denied"];
  public updatedRewardStatus = "";

  // ===== Methods ===== //
  public formatDate = formatDate;

  public submitGiftCard(): void {
    this.loading = true;
    const giftCard = {
      reward_confirmation: this.confirmationNumber,
      reward_status: this.issued ? this.updatedRewardStatus : this.rewardStatus,
      reward_notes: this.notes,
      id: this.card.id
    };

    this.$store.dispatch("handleGiftCard", giftCard)
      .then(() => {
        this.$refs.form.reset();
        this.dialog = false;
        this.loading = false;
      })
      .catch(() => {
        this.error = true;
        this.loading = false;
      });
  };

  get confirmationNumber(): string | null {
    return this.card.confirmation_number ? this.card.confirmation_number : null;
  };
  set confirmationNumber(newVal) {
    this.card.confirmation_number = newVal;
  };
  get rewardStatus(): string | null {
    return this.card.reward_status;
  };
  set rewardStatus(newVal) {
    this.issued && newVal !== null ? this.updatedRewardStatus = newVal : this.card.reward_status = newVal;
  };
  get notes(): string | null {
    return this.card.notes;
  };
  set notes(newVal) {
    this.card.notes = newVal;
  };
  get canSend() {
    if (this.issued) {
      return (this.updatedRewardStatus === "Denied" || (this.updatedRewardStatus === "Issued" && this.confirmationNumber));
    }
    return (this.rewardStatus === "Denied" || (this.rewardStatus === "Issued" && this.confirmationNumber));
  }
};
